import { ECourierPaymentConfirmationStatus } from "../../Enum/ECourierPaymentConfirmationStatus"

export class CourierPaymentRecord {
  id: number

  companyId: number

  companyName: string

  courierId: string

  courierName: string

  courierEmail?: string

  courierPhone?: string

  amount: number

  paymentDate: Date

  notes?: string

  relatedRejectedPaymentRecordId?: number

  confirmationStatus: ECourierPaymentConfirmationStatus

  confirmationDatetime?: Date

  createdDatetime: Date

  constructor(data: Partial<CourierPaymentRecord> = {}) {
    this.id = data.id ?? -1

    this.companyId = data.companyId ?? -1

    this.companyName = data.companyName ?? ""

    this.courierId = data.courierId ?? ""

    this.courierName = data.courierName ?? ""

    this.courierEmail = data.courierEmail

    this.courierPhone = data.courierPhone

    this.amount = Number(data.amount ?? 0)

    this.paymentDate = data.paymentDate ? new Date(data.paymentDate) : new Date()

    this.notes = data.notes

    this.relatedRejectedPaymentRecordId = data.relatedRejectedPaymentRecordId

    this.confirmationStatus = data.confirmationStatus ?? ECourierPaymentConfirmationStatus.Pending

    this.confirmationDatetime = data.confirmationDatetime ? new Date(data.confirmationDatetime) : undefined

    this.createdDatetime = data.createdDatetime ? new Date(data.createdDatetime) : new Date()
  }
}
